import styled, { css } from "styled-components";
import { C } from "Components/WebsiteTheme/WebsiteTheme.style";
import HeroTopVector from "Assets/Images/ClassroomPilot/hero-top-vector.svg";
import HeroBottomVector from "Assets/Images/ClassroomPilot/hero-bottom-vector.svg";

// Match the Classroom Pilot hero while preserving the auth form layout.
export const pilotAuthenticationBackground = css`
	&& {
		background: #fff;
	}

	&& .login-regi-wrapper .auth-wrap-left {
		background-color: #eef5fe;
		overflow: hidden;
	}

	&& .login-regi-wrapper .auth-wrap-left::before {
		background-image: url(${HeroTopVector});
		background-size: 320px;
		pointer-events: none;
	}

	&& .login-regi-wrapper .auth-wrap-left::after {
		background-image: url(${HeroBottomVector});
		background-size: 475px;
		pointer-events: none;
	}

	&& .login-regi-wrapper {
		color: ${C.body};
		font-family: "Outfit", sans-serif;
	}

	&& .login-regi-wrapper h1,
	&& .login-regi-wrapper h2 {
		color: ${C.navy};
	}

	&& .login-regi-wrapper .redfont,
	&& .login-regi-wrapper .forgot-password,
	&& .login-regi-wrapper .portal_login_link a {
		color: ${C.blue};
	}

	&& .login-regi-wrapper a:not(.customs_btn) {
		color: ${C.blue};
	}

	&& .login-regi-wrapper a:not(.customs_btn):hover,
	&& .login-regi-wrapper a:not(.customs_btn):focus-visible {
		color: ${C.navy};
	}

	&& .login-regi-wrapper .customs_btn {
		background: ${C.cta};
		color: #fff;
		border-color: transparent;
		box-shadow: ${C.ctaShadow};
	}

	&& .login-regi-wrapper .customs_btn:hover,
	&& .login-regi-wrapper .customs_btn:focus-visible {
		background: ${C.ctaHover};
		color: #fff;
	}

	&& .login-regi-wrapper .customs_btn:disabled {
		opacity: 0.6;
		cursor: wait;
	}

	&& .login-regi-wrapper .customs_btn svg [fill="#EE2D2F" i] {
		fill: ${C.orange};
	}

	&& .login-regi-wrapper .social_handles svg [fill="#EE2D2F" i] {
		fill: ${C.blue};
		transition: fill 0.2s ease;
	}

	&& .login-regi-wrapper .social_handles a:hover svg [fill="#EE2D2F" i],
	&& .login-regi-wrapper .social_handles a:focus-visible svg [fill="#EE2D2F" i] {
		fill: ${C.navy};
	}

	@media (max-width: 767px) {
		&& .login-regi-wrapper .auth-wrap-left::before {
			background-size: 200px;
		}

		&& .login-regi-wrapper .auth-wrap-left::after {
			background-size: 280px;
		}
	}
`;

export const AuthenticationPage = styled.div`
	${pilotAuthenticationBackground}
`;
